import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ISubscription, ISubscriptionV2 } from '../models/subscription.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  constructor(private http: HttpClient) {
  }

  viewSubscription(subscriptionId: number): Observable<ISubscription> {
    return this.http.get<ISubscription>(
      environment.apiUrl + `/v1/subscriptions/${subscriptionId}`,
    );
  }

  view(accountId: number): Observable<ISubscriptionV2> {
    return this.http.get<ISubscriptionV2>(environment.apiUrl + `/v1/subscriptions/${accountId}`);
  }

  update(accountId: number, data: any): Observable<{ success: boolean }> {
    return this.http.put<{ success: boolean }>(environment.apiUrl + `/v1/subscriptions/${accountId}`, data);
  }

  updateSubscription(
    subscriptionId: number,
    subscriptionInfo: ISubscription,
  ): Observable<{ subscription_id: number }> {
    return this.http.put<{ subscription_id: number }>(
      environment.apiUrl + `/v1/subscriptions/${subscriptionId}`,
      {
        ...subscriptionInfo,
      },
    );
  }

  createSubscription(
    subscriptionInfo: ISubscription,
  ): Observable<{ subscription_id: number }> {
    return this.http.post<{ subscription_id: number }>(
      environment.apiUrl + '/v1/subscriptions',
      {
        ...subscriptionInfo,
      },
    );
  }

  deleteSubscription(subscriptionId: number): Observable<{ success: boolean }> {
    return this.http.delete<{ success: boolean }>(
      environment.apiUrl + `/v1/subscriptions/${subscriptionId}`,
    );
  }
}
